export default { sha: 'c49d59dacc65864dea320421846274230243cb4a', buildNumber: 'undefined' }
